import React, { createContext, useEffect, useState } from 'react';

export const CurrentSingleContext = createContext();

export const CurrentSingleContextProvider = props => {
    const [currentSingle, setCurrentSingle] = useState([]);

    useEffect(() => {
        // setIt()
    }, [])



    return (
        <CurrentSingleContext.Provider value={[currentSingle, setCurrentSingle]}>
            {props.children}
        </CurrentSingleContext.Provider>
    )
}

